export const POLITENESS_24H = 'P6558';
export const AUTOFILL_SKILLS_GROUP = 'P6451';

export const HHTM_SOURCE_VACANCY_RESPONSES = 'employer_vacancy_responses';

export const HHTM_FROM_LABEL_SUITABLE_RESUMES = 'suitable_resumes';
